import Vue from 'vue';
import api from '../../api';

const state = {
  suppliers: [],
};

const getters = {
  suppliers(state) {
    return state.suppliers;
  },
};

const mutations = {
  setSuppliers(state, payload) {
    state.suppliers = payload;
  },
  setSupplier(state, payload) {
    Vue.set(state.suppliers, payload.id, payload);
  },
};

const actions = {
  getSuppliers(context) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.getSuppliers();
        let suppliers = [];
        if (res && res.data && res.data.suppliers && res.data.suppliers.items) {
          suppliers = res.data.suppliers.items;
        }

        context.dispatch('setSuppliers', suppliers);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
  setSuppliers(context, payload) {
    const categories = context.getters.categories || {};
    const suppliers = {};
    payload.forEach(supplier => {
      supplier.category = {};
      supplier.meta = '';

      if (supplier.categoryId) {
        supplier.category = categories[supplier.categoryId];
        if (supplier.category) {
          supplier.meta = supplier.category.name || '';
        }
      }

      const getInitials = name => {
        if (typeof name !== 'string') {
          return '';
        }

        const nameArray = name.split(' ');
        return nameArray
          .map(n => n.charAt(0))
          .slice(0, 4)
          .join('')
          .toUpperCase();
      };

      supplier.initials = getInitials(supplier.name); // supplier.description.substr(0, 3).toUpperCase();
      supplier.supplierId = supplier.id;
      suppliers[supplier.id] = supplier;
    });

    context.commit('setSuppliers', suppliers);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
